import React, { useRef, useEffect, useState } from 'react';
import Lottie from 'lottie-react';

export function SparkOverlay({ show }) {
    const lottieRef = useRef();
    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
        // Fetch the JSON file from the images folder
        fetch('./images/blast.json')
            .then(res => res.json())
            .then(data => setAnimationData(data))
            .catch(err => console.error('Failed to load animation:', err));
    }, []);

    useEffect(() => {
        if (show && lottieRef.current) {
            // Restart animation when shown
            lottieRef.current.goToAndPlay(0);
        }
    }, [show]);

    if (!animationData) return null;

    return (
        <div className={`spark-overlay ${show ? 'show' : ''}`}>
            <Lottie
                lottieRef={lottieRef}
                animationData={animationData}
                loop={true}
                autoplay={true}
                style={{ width: 400, height: 400 }}
            />
        </div>
    );
}
